import NamedDto from 'modules/base/dto/NamedDto';

export class ModelValidationToleranceEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.value = null;
	}

	/**
	 * @typedef {Object} _ModelValidationToleranceEditDtoProps
	 * @property {number} value
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _ModelValidationToleranceEditDtoProps} ModelValidationToleranceEditDtoProps
	 */
	/**
	 *
	 * @param {ModelValidationToleranceEditDtoProps} props
	 * @returns {ModelValidationToleranceEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.value = props.value;

		return this;
	}
}

export default ModelValidationToleranceEditDto;